import type { InsertDataImportMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * Maps the tRPC mutation response ({ Id }) to the GraphQL mutation response
 * shape so consumers branching on the result do not need to know which path
 * executed.
 */
const mapTrpcResponseToGraphQL = (data: {
  Id: string;
}): InsertDataImportMutation => ({
  insert_data_import_one: {
    __typename: 'data_import',
    Id: data.Id,
  },
});

export const useInsertDataImportTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.dataImport.insertDataImport.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.dataImport.dataImports.queryKey(),
        });
      },
    }),
  });

  return {
    insertDataImport: async (): Promise<InsertDataImportMutation> => {
      const result = await mutation.mutateAsync();

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
